import { Box, TextField } from '@mui/material';
import { isMobile, useMobileOrientation } from 'react-device-detect';
import { LocalizationProvider, DateTimePicker, CalendarPickerSkeleton } from '@mui/lab';
import { getData } from "../../api/dataSlice"
import { useSelector } from "react-redux"
import { useTranslation } from 'react-i18next';
import DayjsAdapter from '@mui/lab/AdapterDayjs';
import dayjs from 'dayjs';
import i18next from 'i18next';
import DatePicker from './DatePicker';

export default function Calendar(props) {

    const { t } = useTranslation()
    const { timestamp, setTimestamp, shouldDisableDate, loading, shouldDisableTime, pt = 0 } = props
    const { source } = useSelector(getData)
    const { isPortrait } = useMobileOrientation()

    const minDate = dayjs(source?.[0]?.[0]?.[0])
    const maxDate = dayjs(source?.[0]?.[source[0].length-1]?.[0])

    return (
        <Box>
            <LocalizationProvider
                dateAdapter={DayjsAdapter}
                locale={i18next.language}
            >
                {isMobile && isPortrait ? (
                    <DateTimePicker
                        ampm={false}
                        label={t("date.date_n_time")}
                        inputFormat={(t("date.format.full_date_time"))}
                        mask={t("date.mask.full_date_time")}
                        renderInput={props => <TextField {...props} sx={{ width: "100%" }} />}
                        value={timestamp}
                        onChange={setTimestamp}
                        cancelText={t("actions.cancel")}
                        toolbarTitle={t("date.select_datetime")}
                        minDate={minDate}
                        maxDate={maxDate}
                        loading={loading}
                        shouldDisableDate={shouldDisableDate}
                        shouldDisableTime={shouldDisableTime}
                        renderLoading={() => <CalendarPickerSkeleton />}
                        showTodayButton
                        todayText={t("date.today")}
                    />
                ) : (
                    <DatePicker
                        timestamp={timestamp}
                        setTimestamp={setTimestamp}
                        loading={loading}
                        shouldDisableDate={shouldDisableDate}
                        pt={pt}
                        extended={false}
                    />
                )}
            </LocalizationProvider>
        </Box>
    )
}
